export const placementDeliveryId=(id:unknown):id is string=>typeof id==='string'&&/^[a-f0-9]{64}$/.test(id);
export function placementDeliveryPath(id:string,line:string){
 if(!placementDeliveryId(id)||typeof line!=='string'||!/^[a-zA-Z0-9_-]{1,100}$/.test(line))throw new Error('Choose a saved delivery receipt line.');
 return '/api/put-away/warehouse-receipts/'+id+'/'+line+'/task';
}
